import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

const LOGO_ID = 'header-logo';
const char_1_CLASS = 'char-1';
const char_2_CLASS = 'char-2';
const char_3_CLASS = 'char-3';
const char_4_CLASS = 'char-4';
const char_5_CLASS = 'char-5';

const DURATION = 0.5;

class HeaderLogoAnimations {
    constructor() {
        this._logo = document.getElementById(LOGO_ID);

        this._logo && this._run();
    }
    _run = () => {
        if (!this._isTouchDevice()) {
            this._createAnimationTimeline();
            this._logo.addEventListener('mouseenter', () => {
                this._charAnimation.play();
            });
            this._logo.addEventListener('mouseleave', () => {
                this._charAnimation.pause(0);
            });
        }
    };

    _createAnimationTimeline = () => {
        this._charAnimation = gsap.timeline({
            paused: 'true',
            defaults: {
                ease: 'ease1',
                overwrite: 'auto',
            },
        });

        this._charAnimation.to(`.${char_1_CLASS}`, {
            y: '-100%',
            duration: DURATION,
        });
        this._charAnimation
            .to(
                `.${char_2_CLASS}`,
                {
                    x: '-100%',
                    duration: DURATION,
                },
                '<',
            )
            .to(
                `.${char_3_CLASS}`,
                {
                    y: '-100%',
                    duration: DURATION + 0.1,
                },
                '<',
            )
            .to(
                `.${char_4_CLASS}`,
                {
                    x: '100%',
                    duration: DURATION + 0.1,
                },
                '<',
            )
            .to(
                `.${char_5_CLASS}`,
                {
                    y: '-100%',
                    duration: DURATION + 0.2,
                },
                '<',
            );
    };

    _isTouchDevice = () => {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    };
}

const headerLogoAnimations = new HeaderLogoAnimations();
